import { Link } from "react-router-dom"

/**
 * Renders the short customer/vehicle/source-document info attached to a
 * customer_payment ledger row (see AccountTransactionController::attachReferenceContext).
 * Returns null for every other reference_type — nothing else carries this context yet.
 */
const ReferenceContextInfo = ({ referenceType, context }) => {
  if (referenceType !== "customer_payment" || !context) {
    return null
  }

  const { customer, vehicle, source } = context

  return (
    <div className="small d-flex flex-column gap-1">
      {customer && (
        <div>
          <Link to={`/customer-list/${customer.cuid || customer.id}/view`}>{customer.name}</Link>
          {customer.mobile && <span className="text-muted"> · {customer.mobile}</span>}
        </div>
      )}
      {vehicle && (
        <div>
          <Link to={`/vehicle-stock-inventory-list/${vehicle.id}/view`}>
            {vehicle.stock_id || vehicle.full_chassis || `Vehicle #${vehicle.id}`}
          </Link>
        </div>
      )}
      {source?.type === "money_receipt" && (
        <div>
          <Link to={`/money-receipts/${source.id}`}>{source.label || `MR #${source.id}`}</Link>
        </div>
      )}
      {source?.type === "standalone" && (
        <span className="text-muted fst-italic">Standalone payment (no source document)</span>
      )}
    </div>
  )
}

export default ReferenceContextInfo
